module.exports = __webpack_public_path__ + "img/webhook.b6f0fa13.png";